/**
 *
 * Asynchronously loads the component for Iku001
 * Author: July
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
